import React, { useEffect } from "react";
import { Field, SubmissionError } from "redux-form";
import { phoneNormalize, formatPhone } from "utils/helpers";
import { requiredValidate, phoneNumberValidate } from "../helpers";
import { Loader, FormField } from "pickups-ui-library";
import { Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const CreateUpdateDonor = (props) => {
  const {
    handleSubmit,
    onSubmit,
    onCancel,
    pristine,
    submitting,
    error,
    location,
    initialize,
    initialValues,
  } = props;
  useEffect(() => {
    // need to initialize the form with initialValues from props
    initialize(initialValues);
  }, []);

  // const {leadSources, isFetching} = props.leadSourceOptions;
  const handleLoginSubmit = (form) => {
    const isFromPublicForm =
      location && location.state && location.state.fromPublicForm;
    // if the user is coming from the public donor form, semnd them to the authed schedule component and let that component know
    const callback = () => {
      if (isFromPublicForm) {
        props.history.push("/schedule/5", { isFromPublicForm: true });
      }
    };
    return onSubmit(form, callback).catch(() => {
      throw new SubmissionError({ _error: "Invalid phone number or password" });
    });
  };

  return (
    <form onSubmit={handleSubmit(handleLoginSubmit)}>
      {error && <Alert color={"danger"}>{error}</Alert>}
      <Field
        name="phoneNumber"
        type="phone"
        component={FormField}
        label="Phone Number"
        placeholder=""
        validate={[requiredValidate, phoneNumberValidate]}
        required={true}
      />
      <Field
        name="password"
        type="password"
        component={FormField}
        label="Password"
        placeholder=""
        required={true}
        validate={[requiredValidate]}
      />
      <div className={"mt-n2 mb-1 text-right"}>
        <Link to="/forgot_password">Forgot your password?</Link>
      </div>
      <div className={"mt-4"}>
        <Button type="submit" disabled={pristine || submitting} block>
          {submitting ? <Loader color="#fff" /> : "Login"}{" "}
        </Button>
      </div>
      <div className={"mt-4 mb-1"}>
        <Link to="/schedule">Donate as a guest</Link>
      </div>
    </form>
  );
};

export default withRouter(CreateUpdateDonor);
